import { defineComponent as V, ref as r, provide as j, computed as h, onMounted as q, useCssModule as G, openBlock as L, createElementBlock as N, normalizeClass as c, normalizeStyle as C, createElementVNode as b, Fragment as J, renderList as Q, withModifiers as Y, withKeys as W, toDisplayString as Z, renderSlot as x, nextTick as ee } from "vue";
import { debounce as A } from "lodash-es";
import { CdrColorBackgroundPrimary as te, CdrSpaceHalfX as ae, CdrSpaceOneX as le } from "../../../node_modules/@rei/cdr-tokens/dist/js/cdr-tokens.mjs";
import se from "../../utils/mapClasses.mjs";
import { modifyClassName as B } from "../../utils/buildClass.mjs";
import re from "./styles/CdrTabs.module.scss.mjs";
import ne from "../../../_virtual/_plugin-vue_export-helper.mjs";
const ie = V({
  name: "CdrTabs",
  props: {
    /**
     * Sets height of the tabs container element.
     * Passing a `px` value will render tabs with a static height,
     * passing `auto` will render tabs with variable height based on content size.
     */
    height: {
      type: String,
      default: "240px"
    },
    /** Sets the index of the tab that should be active on initial page load. Note that this property is zero-indexed. */
    activeTab: {
      type: Number,
      default: 0
    },
    /**
     * Modifies the style variants for this component
     * @values centered, compact, full-width, no-border
     */
    modifier: String,
    /**
     * Use `small` to reduce spacing around the tabs for a denser visual design
     * @demoSelectMultiple true
     * @values small
    */
    size: String,
    /**
     * Sets the background color of the tab.
     * For CdrTabs that are rendered on non-primary backgrounds.
     * Pass the background-color into the component to ensure that the scrolling gradients render correctly.
     */
    backgroundColor: {
      type: String,
      default: te
    }
  },
  setup(e, d) {
    var R;
    const T = (R = d.slots.default()[0].children) != null && R.length ? d.slots.default()[0].children : d.slots.default(), z = "cdr-tabs", p = r(T.map((a) => ({
      name: a.props.name,
      disabled: a.props.disabled,
      id: a.props["aria-labelledby"]
    }))), m = r(null), l = r(null), n = r(!1), s = r(0), o = r([]), v = r(null), S = r(null), k = r(!1), w = r(!1), i = r(0), f = r(0);
    j("selectedTabName", m);
    const X = h(() => e.modifier && B("cdr-tabs", e.modifier)), O = h(() => e.size && B("cdr-tabs", e.size)), P = h(() => ({
      transform: `translateX(${i.value}px)`,
      width: `${f.value}px`
    })), F = h(() => ({
      background: `linear-gradient(to left, rgba(255, 255, 255, 0), ${e.backgroundColor})`
    })), _ = h(() => ({
      background: `linear-gradient(to right, rgba(255, 255, 255, 0),
        ${e.backgroundColor})`
    })), H = (a, t) => l.value === a && !t.disabled, y = () => {
      let a = 0;
      if (S.value && (a = S.value.offsetWidth), n.value = s.value > a, n.value) {
        const t = v.value.scrollLeft;
        k.value = t > 1, w.value = t + 1 < s.value - a;
      } else
        k.value = !1, w.value = !1;
    }, E = () => {
      let a = [];
      v.value && (a = Array.from(v.value.children));
      let t = 0;
      return a.forEach((u, $) => {
        $ > 0 && (t += e.size === "small" ? Number(ae) : Number(le)), t += u.offsetWidth || 0;
      }), t;
    }, g = () => {
      if (o.value.length > 0) {
        const t = o.value[l.value].getBoundingClientRect(), u = v.value.getBoundingClientRect(), $ = t.x - u.x;
        i.value = $ - v.value.scrollLeft, f.value = t.width, i.value + f.value >= u.width ? (f.value = Math.max(0, u.width - i.value), i.value = Math.min(i.value, u.width)) : i.value < 0 && (f.value = Math.max(0, f.value + i.value), i.value = 0);
      }
    }, I = async (a) => {
      const t = o.value[a];
      m.value = p.value[a].name, l.value = a, await ee(), t.focus(), g();
    }, K = () => {
      if (l.value === o.value.length - 1)
        return;
      let t = l.value + 1;
      o.value[t].disabled && (t += 1), t <= o.value.length - 1 && I(t);
    }, D = () => {
      if (l.value <= 0)
        return;
      let t = l.value - 1;
      o.value[t].disabled && (t -= 1), t >= 0 && I(t);
    }, M = () => {
      o.value.forEach((a, t) => {
        !a.disabled && l.value === null && (l.value = t, m.value = p.value[t].name);
      });
    };
    q(() => {
      M(), s.value = E(), y(), setTimeout(() => {
        g();
      }, 250), window.addEventListener("resize", A(() => {
        s.value = E(), y(), g();
      }, 250)), v.value.addEventListener("scroll", A(() => {
        y(), g();
      }, 50));
    });
    const U = G();
    return {
      slottedTabs: T,
      baseClass: z,
      tabs: p,
      selectedTabName: m,
      selectedIndex: l,
      headerOverflow: n,
      headerWidth: s,
      tabElements: o,
      tablist: v,
      containerEl: S,
      overflowLeft: k,
      overflowRight: w,
      underlineOffsetX: i,
      underlineWidth: f,
      mapClasses: se,
      modifierClass: X,
      sizeClass: O,
      underlineStyle: P,
      gradientLeftStyle: F,
      gradientRightStyle: _,
      checkIfActive: H,
      calculateOverflow: y,
      getHeaderWidth: E,
      updateUnderline: g,
      selectTabNext: K,
      selectTabPrev: D,
      selectTab: I,
      setInitialTabStates: M,
      style: U
    };
  }
}), oe = ["id", "disabled", "aria-selected", "tabIndex", "onClick"];
function de(e, d, T, z, p, m) {
  return L(), N("div", {
    class: c(e.mapClasses(e.style, e.baseClass, e.modifierClass, e.sizeClass)),
    ref: "containerEl",
    style: C({
      height: e.height
    })
  }, [b("div", {
    class: c(e.style["cdr-tabs__gradient-container"])
  }, [b("div", {
    class: c(e.mapClasses(e.style, "cdr-tabs__gradient", "cdr-tabs__gradient--left", e.overflowLeft ? "cdr-tabs__gradient--active" : "")),
    style: C(e.gradientLeftStyle)
  }, null, 6), b("ul", {
    class: c(e.style["cdr-tabs__header-container"]),
    role: "tablist",
    ref: "tablist"
  }, [(L(!0), N(J, null, Q(e.tabs, (l, n) => (L(), N("li", {
    key: `${l.name}-${n}`,
    role: "presentation",
    class: c(e.style["cdr-tabs__header"])
  }, [b("button", {
    ref_for: !0,
    ref: (s) => {
      e.tabElements[n] = s;
    },
    id: l.id,
    disabled: l.disabled,
    "aria-selected": e.checkIfActive(n, l),
    tabIndex: e.checkIfActive(n, l) ? 0 : -1,
    class: c(e.mapClasses(e.style, e.checkIfActive(n, l) ? "cdr-tabs__header-item-active" : "", "cdr-tabs__header-item", l.disabled ? "cdr-tabs__header-item--disabled" : "")),
    role: "tab",
    onClick: Y((s) => e.selectTab(n), ["prevent"]),
    onKeyup: [d[0] || (d[0] = W((...s) => e.selectTabNext && e.selectTabNext(...s), ["right"])), d[1] || (d[1] = W((...s) => e.selectTabPrev && e.selectTabPrev(...s), ["left"]))]
  }, Z(l.name), 43, oe)], 2))), 128))], 2), b("div", {
    class: c(e.mapClasses(e.style, "cdr-tabs__gradient", "cdr-tabs__gradient--right", e.overflowRight ? "cdr-tabs__gradient--active" : "")),
    style: C(e.gradientRightStyle)
  }, null, 6), b("div", {
    class: c(e.style["cdr-tabs__underline"]),
    style: C(e.underlineStyle)
  }, null, 6)], 2), x(e.$slots, "default")], 6);
}
const ue = {
  $style: re
}, pe = /* @__PURE__ */ ne(ie, [["render", de], ["__cssModules", ue]]);
export {
  pe as default
};
